import { Component, OnInit } from '@angular/core';
import { ClientesService } from 'src/app/services/clientes.service';

@Component({
  selector: 'app-compras-adicionales',
  templateUrl: './compras-adicionales.component.html',
  styleUrls: ['./compras-adicionales.component.scss']
})
export class ComprasAdicionalesComponent implements OnInit {
  respuestaClientes:any;
  data:any;
  filtro;
  clientes:any;

  constructor(private _getClientes:ClientesService) { }

  ngOnInit(): void {
    this.filtro = {
      'alumno':'',
      'apellidos':'',
    }
  }

  getClientesFiltroText(){
    this.data = {
      'alumno':this.filtro.alumno,
      'apellidos':this.filtro.apellidos,
    }
    this._getClientes.getClientesFiltroText(this.data).subscribe(
      data => {
        this.respuestaClientes = data;
        if(this.respuestaClientes.success){
          this.clientes = this.respuestaClientes.content;
          // this.dtTrigger.unsubscribe();
          // this.dtTrigger.next();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));

  }

  nuevaCompra(cliente){
     
  }

}
